var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15776 0.428467H1.27229C0.570696 0.428467 0 0.999163 0 1.70076V18.1562C0 18.8577 0.570696 19.4285 1.27229 19.4285H9.15776C9.85931 19.4285 10.4301 18.8578 10.4301 18.1562V1.70076C10.4301 0.999163 9.85936 0.428467 9.15776 0.428467ZM9.95482 18.1562C9.95482 18.5958 9.59713 18.9535 9.15753 18.9535H1.27229C0.832688 18.9535 0.475 18.5958 0.475 18.1562V16.0099H9.95482V18.1562ZM9.95482 15.5349H0.475V3.06115H9.95482V15.5349ZM9.95482 2.58614H0.475V1.70076C0.475 1.26115 0.832688 0.903467 1.27229 0.903467H9.15753C9.59713 0.903467 9.95482 1.26115 9.95482 1.70076V2.58614Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21503 16.545C4.67592 16.545 4.23724 16.9836 4.23724 17.5227C4.23724 18.0618 4.67592 18.5003 5.21503 18.5003C5.75414 18.5003 6.19282 18.0616 6.19282 17.5225C6.19282 16.9834 5.75414 16.545 5.21503 16.545ZM5.21503 18.0255C4.93787 18.0255 4.71224 17.7999 4.71224 17.5227C4.71224 17.2456 4.93787 17.02 5.21503 17.02C5.49219 17.02 5.71782 17.2456 5.71782 17.5227C5.71782 17.7999 5.49219 18.0255 5.21503 18.0255Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileicon);
export default __webpack_public_path__ + "static/media/Mobileicon.3709bc6f9ad8958c5abffde5497bd786.svg";
export { ForwardRef as ReactComponent };